import React, { useState, useEffect, useMemo, useCallback } from "react";
import { FaSearch, FaFlask, FaHeartbeat, FaBox } from "react-icons/fa";
import {
  getAllLabReport,
  getAllLabReportForCount,
  getOutSourceToLabReport,
  getOutSourceFromLabReport,
  updateBranchInLabReport,
  resetBranchMessage,
  getLabReportsSharedClinic,
} from "../../../store/slices/labReportSlice";
import QuickDateFilter from "../../common/commonFilters/QuickDateFilter";
import CustomDateModal from "../../common/commonFilters/CustomDateModal";

import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import { getParentChildData } from "../../../store/slices/branchSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import styles from "./labReport.module.scss";
import Table from "../../common/Table/table";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { IoPrintOutline } from "react-icons/io5"; 
const LabReport = () => {
  const [serviceTab, setServiceTab] = useState("Pathology");
  const [activeTab, setActiveTab] = useState(0);
  const {
    labReport,
    count,
    labreportShareClinic,
    searchMessage,
    labBranchUpdateErrorMessage,
    labBranchUpdateSuccessMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.labReport);
  const { ParentAndChildData } = useSelector((state) => state.branches);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { physicianInfoNew } = useSelector((state) => state.physician);
  const { token } = useSelector((state) => state.auth);
  const [labFromData, setLabFromData] = useState({
    fromDate: "",
    toDate: "",
  });
  const loginUserType = Number(sessionStorage.getItem("userType"));
  useEffect(() => {
    if (loginUserType === 2) {
      setActiveTab(4);
    }
  }, [loginUserType]);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const clinicId = clinicInfo?.[0]?.clinicId;
  const physicianId = physicianInfoNew?.[0]?._id;
  const physicianClinicId =
    physicianInfoNew?.[0]?.asociatedClinic?.[0]?.clinicId?._id;
  const branchClinicId = loginUserType === 7 ? clinicId : physicianClinicId;
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedClinic, setSelectedClinic] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [quickFilter, setQuickFilter] = useState("");
  const [showDateModal, setShowDateModal] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const fetchLabReports = useCallback(
    ({
      page = 1,
      limit = pageLimit,
      search = searchValue,
      fromDate = labFromData.fromDate,
      toDate = labFromData.toDate,
    }) => {
      if (!token || (!clinicId && !physicianId)) return;

      const payload = {
        token,
        currentPage: page,
        limit,
        searchQuery: search,
        fromDate,
        toDate,
        serviceName: serviceTab,
      };

      if (loginUserType === 7 && clinicId) {
        payload.clinicId = clinicId;
      }

      if (loginUserType === 2 && physicianId && physicianClinicId) {
        payload.clinicId = physicianClinicId;
        payload.physicianId = physicianId;
      }
      if (activeTab === 4) {
        payload.assignDoctorDate = new Date();
      }

      if (activeTab === 5) {
        payload.labReportStatus = "In progress";
      }
      switch (activeTab) {
        case 0:
        case 4:
        case 5:
          dispatch(getAllLabReport(payload));
          break;

        case 1:
          dispatch(getOutSourceToLabReport(payload));
          break;

        case 2:
          dispatch(getOutSourceFromLabReport(payload));
          break;

        case 3:
          dispatch(getLabReportsSharedClinic(payload));
          break;

        default:
          break;
      }
    },
    [
      token,
      clinicId,
      physicianId,
      physicianClinicId,
      loginUserType,
      activeTab,
      labFromData,
      pageLimit,
      searchValue,
      dispatch,
      serviceTab,
    ],
  );

  useEffect(() => {
    if (!token) return;

    if (loginUserType === 7 && !clinicId) return;

    if (loginUserType === 2 && (!physicianId || !physicianClinicId)) return;

    fetchLabReports({
      page: 1,
      limit: pageLimit,
      search: searchValue,
      serviceName: serviceTab,
    });
  }, [
    token,
    clinicId,
    physicianId,
    physicianClinicId,
    loginUserType,
    activeTab,
    pageLimit,
    searchValue,
    fetchLabReports,
    serviceTab,
  ]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchLabReports({
      page: newPage,
      limit: pageLimit,
      search: searchValue,
      serviceName: serviceTab,
    });
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    setPage(1);

    fetchLabReports({
      page: 1,
      limit: newLimit,
      search: searchValue,
      fromDate: labFromData.fromDate,
      toDate: labFromData.toDate,
      serviceName: serviceTab,
    });
  };
  useEffect(() => {
    if (!branchClinicId) return;

    dispatch(
      getParentChildData({
        clinicId: branchClinicId,
        branchRequest: "Accepted",
        token,
      }),
    );
  }, [branchClinicId, token, dispatch]);
  const handleApplyQuickFilter = (from, to) => {
    if (from === "custom_open" && to === "custom_open") {
      setShowDateModal(true);
      return;
    }

    setLabFromData({ fromDate: from, toDate: to });

    fetchLabReports({
      page: 1,
      limit: pageLimit,
      search: searchValue,
      fromDate: from,
      toDate: to,
      serviceName: serviceTab,
    });
  };

  useEffect(() => {
    showTostifyMessageAndReset(
      labBranchUpdateSuccessMessage,
      showToastifySuccess,
      resetBranchMessage,
    );
    showTostifyMessageAndReset(
      labBranchUpdateErrorMessage,
      showToastifyError,
      resetBranchMessage,
    );
  }, [
    labBranchUpdateSuccessMessage,
    labBranchUpdateErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    setPage(1);

    fetchLabReports({
      page: 1,
      limit: pageLimit,
      search: value,
      serviceName: serviceTab,
    });
  };

  const handlePrint = useCallback(
    (item) => {
      if (item?.reportType === "allReports") {
        sessionStorage.setItem("allReportsId", item?.id);
        sessionStorage.removeItem("outSourceToId");
        sessionStorage.removeItem("outSourceFromId");
      } else if (item?.reportType === "outSourceTo") {
        sessionStorage.setItem("outSourceToId", item?.id);
        sessionStorage.removeItem("outSourceFromId");
        sessionStorage.removeItem("allReportsId");
      } else if (item?.reportType === "outSourceFrom") {
        sessionStorage.setItem("outSourceFromId", item?.id);
        sessionStorage.removeItem("outSourceToId");
        sessionStorage.removeItem("allReportsId");
      }
      sessionStorage.setItem("patientId", item?.patientId);
      sessionStorage.setItem("appointmentId", item?.appointmentId);
      // navigate("/viewLabReport");
      navigate("/labReportPdf");
    },
    [navigate],
  );

  const handleEditLabReport = useCallback(
    (id) => {
      sessionStorage.setItem("labReportId", id.id);
      navigate("/editLabReport");
    },
    [navigate],
  );

  const tableHead = useMemo(() => {
    switch (activeTab) {
      case 0:
      case 4:
      case 5:
        return [
          { title: "APT Id", key: "appointmentId" },
          { title: "Patient Name", key: "name" },
          { title: "Appt Date", key: "appDate" },
          { title: "Service", key: "serviceName" },
          { title: "OutSource To", key: "outSourceTo" },
          { title: "OutSource From", key: "outSourceFrom" },
          { title: "Status", key: "status" },
          { title: "Branch Name", key: "branchName" },
          {title: "Updated By", key: "updatedBy"}
        ];
      case 1:
        return [
          { title: "APT Id", key: "appointmentId" },
          { title: "Patient Name", key: "name" },
          { title: "Test List", key: "labTestList" },
          { title: "Appt Date", key: "appDate" },
          { title: "Service", key: "serviceName" },
          { title: "OutSource To", key: "outSourceTo" },
          { title: "Status", key: "status" },
        ];
      case 2:
        return [
          { title: "APT Id", key: "appointmentId" },
          { title: "Patient Name", key: "name" },
          { title: "Test List", key: "labTestList" },
          { title: "Appt Date", key: "appDate" },
          { title: "Service", key: "serviceName" },
          { title: "OutSource From", key: "outSourceFrom" },
          { title: "Status", key: "status" },
        ];
      case 3:
        return [
          { title: "APT Id", key: "appointmentId" },
          { title: "Patient Name", key: "name" },
          { title: "Appt Date", key: "appDate" },
          { title: "Service", key: "serviceName" },
          { title: "OutSource To", key: "outSourceTo" },
          { title: "OutSource From", key: "outSourceFrom" },
          { title: "Status", key: "status" },
          { title: "Request Branch", key: "branchName" },
        ];
      default:
        return [];
    }
  }, [activeTab]);

  const tableBody = useMemo(() => {
    switch (activeTab) {
      case 0:
      case 4:
      case 5:
        return (
          labReport &&
          (labReport?.map((item) => ({
            id: item?._id,
            appointmentId: item?.appointmentId,
            name: item?.patientId?.userId?.name,
            labTestList: item?.tests
              ?.map((test) => test?.testName)
              ?.concat(item?.profiles?.map((profile) => profile?.profileName))
              ?.join(", "),
            appDate: new Date(item?.appDate)?.toISOString()?.split("T")[0],
            serviceName: item?.service?.serviceName,
            outSourceTo:
              item?.labForOutsource?.clinicName ||
              item?.unRegisteredlabForOutsource?.clinicName,
            outSourceFrom: item?.outsourceBy?.clinicName,
            totalAmount: item?.totalAmount,
            status: item?.status,
            patientId: item?.patientId?._id,
            reportType: "allReports",
            status: item?.labReportStatus,
            branchName:
              item?.otherAceess
                ?.map((branch) => branch?.clinicName)
                ?.join(", ") || "N/A",
            updatedBy: item?.updatedBy?.name,
          })) ||
            [])
        );
      case 1:
        return (
          labReport &&
          (labReport?.map((item) => ({
            id: item?._id,
            appointmentId: item?.appointmentId,
            name: item?.patientId?.userId?.name,
            labTestList: item?.tests
              ?.map((test) => test?.testName)
              ?.concat(item?.profiles?.map((profile) => profile?.profileName))
              ?.join(", "),
            appDate: new Date(item?.appDate)?.toISOString()?.split("T")[0],
            serviceName: item?.service?.serviceName,
            totalAmount: item?.totalAmount,
            outSourceTo:
              item?.labForOutsource?.clinicName ||
              item?.unRegisteredlabForOutsource?.clinicName,
            status: item?.status,
            patientId: item?.patientId?._id,
            reportType: "outSourceTo",
          })) ||
            [])
        );
      case 2:
        return (
          labReport &&
          (labReport?.map((item) => ({
            id: item?._id,
            appointmentId: item?.appointmentId,
            name: item?.patientId?.userId?.name,
            labTestList: item?.tests
              ?.map((test) => test?.testName)
              ?.concat(item?.profiles?.map((profile) => profile?.profileName))
              .join(", "),
            appDate: new Date(item?.appDate)?.toISOString()?.split("T")[0],
            serviceName: item?.service?.serviceName,
            totalAmount: item?.totalAmount,
            outSourceFrom: item?.outsourceBy?.clinicName,
            status: item?.status,
            patientId: item?.patientId?._id,
            reportType: "outSourceFrom",
          })) ||
            [])
        );
      case 3:
        return (
          labreportShareClinic &&
          (labreportShareClinic?.map((item) => ({
            id: item?._id,
            appointmentId: item?.appointmentId,
            name: item?.patientId?.userId?.name,
            labTestList: item?.tests
              ?.map((test) => test?.testName)
              ?.concat(item?.profiles?.map((profile) => profile?.profileName))
              .join(", "),
            appDate: new Date(item?.appDate)?.toISOString()?.split("T")[0],
            serviceName: item?.service?.serviceName,
            totalAmount: item?.totalAmount,
            outSourceFrom: item?.outsourceBy?.clinicName,
            status: item?.status,
            patientId: item?.patientId?._id,
            reportType: "outSourceFrom",
            status: item?.labReportStatus,
            branchName: item?.clinicId?.clinicName,
          })) ||
            [])
        );
      default:
        return [];
    }
  }, [activeTab, labReport, labreportShareClinic]);

  const handleTab = (tab) => {
    setActiveTab(tab);
    setSearchValue("");
    setLabFromData({ fromDate: "", toDate: "" });
    setPage(1);
  };

  const handleClear = () => {
    setLabFromData({ fromDate: "", toDate: "" });
    setSearchValue("");
    setQuickFilter("");
    setPage(1);

    fetchLabReports({
      page: 1,
      limit: pageLimit,
      search: "",
      fromDate: "",
      toDate: "",
      serviceName: serviceTab,
    });
  };

  const handleShare = (item) => {
    setSelectedItem(item);
    setShowShareModal(true);
  };
  const handleShareSubmit = () => {
    if (!selectedClinic || !selectedItem?.appointmentId) {
      return;
    }
    const payload = {
      appointmentId: selectedItem.appointmentId,
      clinicId: selectedClinic,
      token,
    };

    dispatch(updateBranchInLabReport(payload)).then((res) => {
      setShowShareModal(false);
    });
  };

  const tableData = useMemo(
    () => (
      <Table
        tableHead={tableHead}
        tableBody={tableBody}
        handlePrint={handlePrint}
        handleEdit={handleEditLabReport}
        // handleShowGlobalViewModal={handleShowGlobalViewModal}
        disableRowClick={true}
        errorMessage={searchMessage}
        searchValue={searchValue}
        filterDateForSearch={labFromData.fromDate || labFromData.toDate}
        handleShare={handleShare}
        setShowShareModal={setShowShareModal}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onLimitChange={handleLimitChange}
        onPageChange={handlePageChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
        hideStatusTab={true}
        showPrintButton={true}
      />
    ),
    [
      tableHead,
      tableBody,
      handlePrint,
      handleEditLabReport,
      // handleShowGlobalViewModal,
      searchValue,
      searchMessage,
      labFromData,
      currentPage,
      totalPages,
      totalCount,
      pageLimit,
      handleLimitChange,
      handlePageChange,
    ],
  );

  useEffect(() => {
    if (!token) return;

    if (loginUserType === 2 && physicianId && physicianClinicId) {
      dispatch(
        getAllLabReportForCount({
          token,
          clinicId: physicianClinicId,
          physicianId: physicianId,
        }),
      );
    }
  }, [token, physicianId, physicianClinicId, loginUserType, dispatch]);

  const { assignedCount, pendingCount, approvedCount } = useMemo(() => {
    if (!count || !Array.isArray(count)) {
      return { assignedCount: 0, pendingCount: 0, approvedCount: 0 };
    }

    const today = new Date().toISOString().split("T")[0];

    let assigned = 0;
    let pending = 0;
    let approved = 0;

    count.forEach((item) => {
      const assignDate = item?.assignDoctorDate?.split("T")[0];
      const updatedDate = item?.updatedAt?.split("T")[0];

      if (assignDate === today) {
        assigned++;
      }

      if (item?.labReportStatus === "In progress") {
        pending++;
      }

      if (updatedDate === today && item?.labReportStatus === "Final") {
        approved++;
      }
    });

    return {
      assignedCount: assigned,
      pendingCount: pending,
      approvedCount: approved,
    };
  }, [count]);

  return (
    <>
      <div className={styles.serviceTabs}>
        <div
          className={`${styles.serviceTab} ${
            serviceTab === "Pathology" ? styles.active : ""
          }`}
          onClick={() => setServiceTab("Pathology")}
        >
          <FaFlask />
          <span>Pathology</span>
        </div>

        <div
          className={`${styles.serviceTab} ${
            serviceTab === "Health-Screening" ? styles.active : ""
          }`}
          onClick={() => setServiceTab("Health-Screening")}
        >
          <FaHeartbeat />
          <span>Health Screening</span>
        </div>

        <div
          className={`${styles.serviceTab} ${
            serviceTab === "Health-Package" ? styles.active : ""
          }`}
          onClick={() => setServiceTab("Health-Package")}
        >
          <FaBox />
          <span>Health Package</span>
        </div>
      </div>
      <div className="row d-flex align-items-center">
        <div className="col-md-4">
          <QuickDateFilter
            quickFilter={quickFilter}
            setQuickFilter={setQuickFilter}
            onApply={handleApplyQuickFilter}
          />
        </div>

        <div className="col-md-4">
          <button
            className="btn btn-primary mt-3"
            onClick={() =>
              fetchLabReports({ page: 1, serviceName: serviceTab })
            }
          >
            Filter
          </button>
          <button className="btn btn-danger mt-4 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>

        <div className={classNames("col-md-4 mt-4", styles["search-area"])}>
          <input
            type="text"
            className={classNames("form-control", styles["search-input"])}
            placeholder="Search here"
            onChange={handleSearch}
          />
          <FaSearch className="flaticon-381-search-2" />
        </div>
      </div>
      <div className={styles["tabWrapper"]}>
        <div className={styles["tabs"]}>
          {loginUserType !== 2 && (
            <>
              <p
                className={activeTab === 0 ? styles["active"] : ""}
                onClick={() => handleTab(0)}
              >
                All Reports
              </p>

              <p
                className={activeTab === 1 ? styles["active"] : ""}
                onClick={() => handleTab(1)}
              >
                Out Source To
              </p>

              <p
                className={activeTab === 2 ? styles["active"] : ""}
                onClick={() => handleTab(2)}
              >
                Out Source From
              </p>

              <p
                className={activeTab === 3 ? styles["active"] : ""}
                onClick={() => handleTab(3)}
              >
                Share Data
              </p>
            </>
          )}
          {loginUserType !== 7 && (
            <div className={styles.statusTabs}>
              <button
                className={`${styles.statusBtn} ${
                  activeTab === 4 ? styles.activeStatus : ""
                }`}
                onClick={() => handleTab(4)}
              >
                Assigned
                <span className={`${styles.badge} ${styles.blue}`}>
                  {assignedCount}
                </span>
              </button>

              <button
                className={`${styles.statusBtn} ${
                  activeTab === 5 ? styles.activeStatus : ""
                }`}
                onClick={() => handleTab(5)}
              >
                Pending
                <span className={`${styles.badge} ${styles.yellow}`}>
                  {pendingCount}
                </span>
              </button>

              <button
                className={`${styles.statusBtn} ${styles.disabled}`}
                disabled
              >
                Approved
                <span className={`${styles.badge} ${styles.green}`}>
                  {" "}
                  {approvedCount}
                </span>
              </button>
            </div>
          )}
        </div>

        {tableData}
      </div>
      <CustomDateModal
        show={showDateModal}
        onClose={() => setShowDateModal(false)}
        onApply={(start, end) => {
          const from = start;
          const to = end;

          setLabFromData({ fromDate: from, toDate: to });
          setShowDateModal(false);

          fetchLabReports({
            page: 1,
            limit: pageLimit,
            search: searchValue,
            fromDate: from,
            toDate: to,
            serviceName: serviceTab,
          });
        }}
      />

      {showShareModal && (
        <Modal
          show={showShareModal}
          onHide={() => setShowShareModal(false)}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title">Share Report</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowShareModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label>Select Clinic</label>
              <Select
                options={
                  Array.isArray(ParentAndChildData?.clinics)
                    ? ParentAndChildData.clinics.map((clinic) => ({
                        label: clinic.clinicName,
                        value: clinic._id,
                      }))
                    : []
                }
                onChange={(selected) => setSelectedClinic(selected?.value)}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowShareModal(false)}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleShareSubmit}
            >
              Share
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default LabReport;
